export enum ReassignmentActionEnum {
  Nothing = 'Nothing',
  AssignNew = 'AssignNew',
  TerminateAndReassign = 'TerminateAndReassign',
  Terminate = 'Terminate'
}
